/** @file Writes the 4 world-space corners of a region attachment for one bone world matrix. */
import type { RegionAttachmentData } from '@pose2d/core/types';
import { writeWorldPoints } from './_internal/writeWorldPoints';

/** Writes 8 floats (BL, TL, TR, BR) into out at offset; returns offset + 8. */
export function regionQuad(out: Float32Array, offset: number, att: RegionAttachmentData, world: Float64Array, worldOffset: number): number {
  return writeWorldPoints(out, offset, att.local, null, 4, world, worldOffset);
}
